import Aos from "aos";
import { useEffect } from "react";

const BankvoleReferralSection = () => {
  useEffect(() => {
        Aos.init({
            duration: 1000,
        });
    }, []);
  return (
    <section className="bv-referrals">
      <div className="bv-referral">
      <div className="bv-referral-left" data-aos="fade-up" data-aos-duration="1000">
        <span className="bv-eyebrow">REFER &amp; EARN</span>
        <h2 className="bv-referral-title">
          Share Bankvole. <br /> Earn rewards <br /> together.
        </h2>
        <p className="bv-referral-text">
          Invite your friends and family to sign up, use Bankvole, and earn
          rewards.
        </p>
      </div>

      <div className="bv-referral-right" data-aos="fade-up" data-aos-duration="1000">
        <img
          src={`${process.env.PUBLIC_URL}/assets/img/bankvole-referral.png`}
          alt="Friends sharing Bankvole rewards"
          className="bv-referral-img"
        />
      </div>
      </div>
    </section>
  );
};

export default BankvoleReferralSection;
